import { render, staticRenderFns } from "./OrderUpdateForm.vue?vue&type=template&id=159fad3e&"
import script from "./OrderUpdateForm.vue?vue&type=script&lang=js&"
export * from "./OrderUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports